export function ImgKeyArrow({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 7v10M19 17H7M7 17l4-4M7 17l4 4"/>
    </svg>
  );
}
